import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { UserData } from '../../providers/user-data'
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { ToastController } from 'ionic-angular';
import { AlertController } from 'ionic-angular';
import { GlobalVariable } from '../../global';
import { HomePage } from '../home/home';
import { Storage } from '@ionic/storage';

/**
 * Generated class for the UpdateUserFormPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-update-user-form',
  templateUrl: 'update-user-form.html',
})
export class UpdateUserFormPage {
  userid: any
  usertype: any
  username: any
  userForm: FormGroup
  constructor(public navCtrl: NavController, public navParams: NavParams, private toastCtrl: ToastController,
    private alertCtrl: AlertController, public userData: UserData, public formBuilder: FormBuilder,
    private storage: Storage) {
    this.storage.get('usertype').then((value) => {
      this.usertype = value;
      if (this.usertype != GlobalVariable.Admin) {
        this.navCtrl.setRoot(HomePage);
      }
    });
    this.userid = navParams.get("userid");
    this.usertype = navParams.get("usertype");
    this.userForm = this.formBuilder.group({
      organisationid: ['', Validators.required],
      userid: ['', Validators.required],
      usertype: ['', Validators.required],
      title: ['', Validators.required],
      surname: ['', Validators.required],
      forename: ['', Validators.required],
      emailaddress: ['', [Validators.required, Validators.email]],
      contactnumber: ['', [Validators.required, Validators.pattern(/^\d+$/)]]
    });
    this.getUserByUserId(this.userid)
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad UpdateUserFormPage');
  }

  getUserByUserId(userid) {
    this.userData.getUserByUserId(userid).subscribe(
      res => {
        let data = res['data']
        console.log(data)
        this.username = data[0].logonid
        this.userForm.get('organisationid').setValue(data[0].defaultorganisationid);
        this.userForm.get('userid').setValue(data[0].userid);
        this.userForm.get('usertype').setValue(data[0].usertype);
        this.userForm.get('title').setValue(data[0].title);
        this.userForm.get('surname').setValue(data[0].surname.toString());
        this.userForm.get('forename').setValue(data[0].forename.toString());
        this.userForm.get('emailaddress').setValue(data[0].emailaddress.toString());
        this.userForm.get('contactnumber').setValue(data[0].contactnumber);
      },
      err => {
        this.presentAlert('Error', 'something went wrong, try again')
      }
    )
  }

  onsubmit(value) {
    this.userData.updateUser(value).subscribe(
      res => {
        if (res['success']) {
          this.presentToast('User Updated Successfully')
        }
      },
      err => {
        this.presentAlert('Error', 'something went wrong, try again')
      }
    )
  }

  presentToast(msg) {
    let toast = this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top',
      showCloseButton: true
    });
    toast.present();
  }

  presentAlert(title, msg) {
    let alert = this.alertCtrl.create({
      title: title,
      subTitle: msg,
      buttons: ['Dismiss']
    });
    alert.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/update-user-form/update-user-form.ts